import { gql } from '@apollo/client';

export const GET_TEMPLATE_FILE = gql`
    query GetTemplateFile($inputType: String!) {
        getManualImportTemplateFile(inputType: $inputType) {
            buffer
            fileName
        }
    }
`;
